var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 417,
    viewBox: "0 0 328 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3154_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.711 32.2807L256.342 28.4453L253.711 32.2808C275.136 46.9734 292.523 66.8149 304.276 89.9818C319.101 119.613 324.827 152.968 320.732 185.848C316.637 218.731 302.903 249.666 281.26 274.758L281.222 274.803L281.184 274.848L172.498 406.989L172.498 406.99C171.466 408.245 170.169 409.256 168.699 409.95C167.229 410.645 165.625 411.005 164 411.005C162.375 411.005 160.771 410.645 159.302 409.95C157.831 409.256 156.534 408.245 155.503 406.99L155.502 406.989L46.8152 274.848L46.7781 274.803L46.7398 274.758C25.0961 249.665 11.3618 218.728 7.26708 185.843C3.17292 152.964 8.89848 119.609 23.7227 89.9767C35.4807 66.8115 52.871 46.9721 74.2964 32.2807C95.7252 17.587 120.503 8.5144 146.353 5.89629C158.092 4.71878 169.917 4.71881 181.656 5.89638C207.506 8.51283 232.284 17.5856 253.711 32.2807Z",
    fill: "#FB5968",
    stroke: "white",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 240C208.183 240 244 204.183 244 160C244 115.817 208.183 80 164 80C119.817 80 84 115.817 84 160C84 204.183 119.817 240 164 240Z",
    fill: "#D8304C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3154_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 417,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.49a6c7d2ccfe9bcb016f34bc603d5309.svg";
export { ForwardRef as ReactComponent };